import { render, staticRenderFns } from "./HistologContrastPanel.vue?vue&type=template&id=367aa196&scoped=true"
import script from "./HistologContrastPanel.vue?vue&type=script&lang=js"
export * from "./HistologContrastPanel.vue?vue&type=script&lang=js"
import style0 from "./HistologContrastPanel.vue?vue&type=style&index=0&id=367aa196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367aa196",
  null
  
)

export default component.exports